import { AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, debounceTime, Observable, Subscription } from 'rxjs';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { FormValidation } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';
import { UpgradeMessageComponent } from 'src/app/upgrade-message/upgrade-message.component';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-customer-network',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxDatatableModule, PlanCardComponent, CustomerSearchComponent, TimezoneDatePipe,
UpgradeMessageComponent, NodataFoundComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-network.component.html',
  styleUrls: ['./customer-network.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class CustomerNetworkComponent extends FormValidation implements OnInit, OnDestroy, AfterViewChecked {

  @Input() screenName: string;
  PLANMAX: any;
  AVAILABLE: any;
  ALLOCATED: any;
  bsModalRef: BsModalRef;
  showModal: boolean = false;
  plan: any;

  businessData: any;
  businessDetails: any;
  businessEmail: string;
  textFields: Array<Partial<TEXT_FIELDS>>;
  businesPlan: any;
  networkData: any;
  refreshSubcription: Subscription;
  businessId: any;
  filterSubscription: Subscription;
  businessOwner: any;
  searchSubscription: Subscription;
  MemberShipType :any;
  isBusinessOrEnterpriseUser: boolean = false;
  businessParams: any;
  allocationCards: { name: string; value: number }[] = [];

  role:any
  constructor(
    private _activated_route: ActivatedRoute,
    private apiService: ApiService,
    private util: UtilService,
    private modalService: BsModalService,
    private customerService: CustomerService,
    private excel: ExcelService,
    private renderer: Renderer2, private el: ElementRef,) {
    super();

    this.refreshSubcription = this.customerService.getRefreshKey().subscribe(ress => {
      if (ress === "network") {
        // this.getNetworklist();
        this.nextPage({offset:0})
      }
    });

    this.filterSubscription = this.customerService.getFilterValue().subscribe(res => {
      if (res.key === 'network') {
        this.params.page = 0;
        this.params.status = res.value.status;
        this.params.searchContent = null;
        this.customerService.setFilterPayload(this.params);
        this.getNetworklist();
      }
    });

    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response => {
      if (response.key === "network") {
        this.params.page = 0;
        this.params.searchContent = response.value;
        this.getNetworklist();
      }
    });

    this._activated_route.parent.data.subscribe(res => {
      this.businessDetails = res.data;
      this.businessName = this.businessDetails.businessName;
      this.bid = this.businessDetails.bid;
      this.MemberShipType=this.businessDetails.plan
      this.role=this.businessDetails.role
      this.businessId = this.businessDetails.id;
      this.businessEmail = this.businessDetails.businessEmail
        this.businessOwner = this.businessDetails.businessOwner;
      });
      const defaultValues = this.MemberShipType === "Free"
      ? [5, 0, 5]
      : [null, null, null];
  const cardNames = ["Plan Max", "Allocated", "Available"];
  this.allocationCards = cardNames.map((name, index) => ({
    name,
    value: defaultValues[index],
  }));

    this.textFields = [
      { label: "Networks", key: "businessNetworkName", value: null, type: "STRING" },
      { label: "Owner", key: "businessnetworkOwner", value: this.businessnetworkOwner, type: "STRING" },
      { label: "Email", key: "gigsumoNo", value: this.businessEmail, type: "STRING" },
      { label: "Role", key: "userType", value: "Super Admin", type: "STRING" },
      { label: "Members", key: "membersCount", value: null, type: "STRING" },
      { label: "Created Date", key: "createdOn", value: null, type: "DATE" },
      { label: "Last Active", key: "modifiedOn", value: null, type: "DATE" },
      { label: "Status", key: "status", value: null, type: "STRING" },
    ]
  }

  listToShow$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  businessid: any
  public selected = [];
  ngOnInit(): void {
    this.checkUserPlan(this.MemberShipType);
    if(this.MemberShipType!="Free"){
      this.getNetworklist();
    }
  }
    @ViewChild('sortTable') table: any;
    onSort(event) {
      const currentPage = this.params.page-1;
      this.table.offset = currentPage;
  }
  checkUserPlan(memberShipType: string) {
    this.isBusinessOrEnterpriseUser = this.customerService.isBusinessOrEnterprise(memberShipType);
  }
  scrollSynced = false; // Flag to prevent multiple bindings
  bodyScrollUnlistener: () => void; // To store the unlistener for clean-up
  resizeUnlistener: () => void; // To store resize unlistener

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }

  // Browser detection function to check if the browser is Firefox
  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  ngOnDestroy(): void {

    if (this.refreshSubcription) {
      this.refreshSubcription.unsubscribe();
    }

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }
    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }

  businessName: string;
  bid: string;

  totalCount = 0;
  params: any = {
    limit: 10,
    page: 1,
    total: 0
  };

  closeModal(data) {
    this.showModal = false;

    if (data.content === "SUCESS") {
      this.getNetworklist();
    }

  }


  nodatafound() {

    // this.listToShow$.next([...[
    //   {
    //     dummyData: true,
    //     businessNetworkName: 'No data to display',
    //   }
    // ]]);
    // this.params.total = 0;

  }

  selectedItem: string = 'network';
businessnetworkOwner:any
getNetworklist() {
  this.params.businessId = this.businessId;
  this.util.startLoader();
  this.getNetworkList(this.params)
    .subscribe({
      next: (res) => {
        this.util.stopLoader();
        if (res && res.code === "00000") {
          const networkData = res.data && res.data.businessNetworkList;
          this.params.total = res.data.total;
          this.excel.setCount(this.params.total);
          this.businessData = res.data.businessData;
          this.businessnetworkOwner=this.businessData.userData.firstName+" "+this.businessData.userData.lastName;
          this.businesPlan = res.data.businessPlanUsage.benefitsUsages.find(x => x.benefitKey as BENEFITS_KEY === 'PERSONAL_NETWORKS');
          const membershipType = res.data.businessPlanUsage.membershipType;
          if (this.businesPlan) {
            this.AVAILABLE = this.businesPlan.actual == 99999999 ? 'Unlimited' : this.businesPlan.available;
            this.ALLOCATED = this.businesPlan.utilized;
            this.PLANMAX = this.businesPlan.actual == 99999999 ? 'Unlimited' : this.businesPlan.actual;
            this.allocationCards = [
              { name: "Plan Max", value: this.PLANMAX },
              { name: "Allocated", value: this.ALLOCATED },
              { name: "Available", value: this.AVAILABLE },
            ];
          }
          if (this.businesPlan && membershipType) {
            let plandetails = {
              actual:this.businesPlan.actual,
              available: this.businesPlan.available,
              promotional:this.businesPlan.promotional,
              utilized:this.businesPlan.utilized,
              membershipType:membershipType
            };
          }

            if (networkData) {
              networkData.forEach(element => {
                element.businessEmail = this.businessEmail;
                element.businessnetworkOwner = this.businessnetworkOwner;
              });
              this.listToShow$.next([...networkData]);
              console.log("customer dsdsd" , this.listToShow$.getValue());
              const userData = this.listToShow$.getValue();
              if (userData) {
                userData.forEach(e => {
                  e.owner = this.businessEmail;
                  e.role = 'Super Admin';

                })
              }
              this.customerService.setUserData(this.listToShow$.getValue());

            }

            if (this.params.page == 0) {
              this.params.total = res.data?.total;
            }
          }
        },
        error: (error) => {
          this.listToShow$.next([]);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching data. Please try again later.",
          });
        }
      });
  }


  getNetworkList(payload: Object): Observable<any> {
    return this.apiService.create('business/getBusinessUsersNetworkList', payload);
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  nextPage(data: any) {
    this.params.page = data.offset + 1;
    if (this.params.page == 0) {
      this.params.page = 0;
    }

    this.getNetworklist();
  }



  openViewModal(datas: any) {

    if (datas) {
      Object.keys(datas).map(key => {
        this.textFields.forEach(vv => {

          if (vv.label === "Allocated" || vv.label === 'Available') {
            vv.value = this.curryObject(datas, 'benefitsUsageAndBalance')(vv.label === "Allocated" ? "actual" : "available");
            return;
          }

          if (vv.key == key) {
            vv.value = datas[key];
          }

        });
      });
    }

    if (this.textFields) {
      this.openView("Network Details", this.textFields, this.modalService,this.util);
    }

  }

  getNetworkParams(row) {
    return { ...this.businessDetails, networkId: row.businessNetworkId, };
  }



}
